import React from "react";
import Banner from "../components/body/careersPageComponents/Banner";
import Navbar from "../components/Navbar/Navbar";

import { careerData } from "./data";
import JobCard from "../components/body/careersPageComponents/JobCard";
import Main_Footer from "../components/footer/IndiaFooter/Main_Footer";

const CareerPage = () => {
  console.log(careerData); // Debug
  return (
    <div>
      <Navbar />
      <Banner careerData={careerData} />
      <JobCard careerData={careerData} /> 
      <Main_Footer/>
    </div>
  );
};

export default CareerPage;
